// extracted by mini-css-extract-plugin
export var active = "GlobalSearch-module--active--1PyGM";
export var bxTextTruncateEnd = "GlobalSearch-module--bx--text-truncate--end--18fpt";
export var bxTextTruncateFront = "GlobalSearch-module--bx--text-truncate--front--3y0SC";
export var container = "GlobalSearch-module--container--3TIOV";
export var description = "GlobalSearch-module--description--2qR3z";
export var hidden = "GlobalSearch-module--hidden--7TwBV";
export var inactive = "GlobalSearch-module--inactive--3zkaQ";
export var input = "GlobalSearch-module--input--1RYUv";
export var inputFocusWithin = "GlobalSearch-module--inputFocusWithin--3IFod";
export var inputWrapper = "GlobalSearch-module--inputWrapper--3VLgN";
export var label = "GlobalSearch-module--label--2te-t";
export var link = "GlobalSearch-module--link--2sbD-";
export var list = "GlobalSearch-module--list--2dE0v";
export var searchButton = "GlobalSearch-module--searchButton--gHiWu";
export var searchButtonClose = "GlobalSearch-module--search-button--close--1LsvZ";
export var skeleton = "GlobalSearch-module--skeleton--h_HDA";
export var tab = "GlobalSearch-module--tab--3HLqL";